<template>
  <div class="header-box color-f-bg">
    <div class="out-box flex">
      <div class="logo p-l-10 pointer" @click="handleHome">
        <el-popover placement="bottom" trigger="hover">
          <img width="180px" src="@/assets/index/hxy_app.png" alt="" />
          <div slot="reference" class="flex-center">
            <img src="@/assets/index/logo.png" alt="" />
            <div class="font-bold m-l-10">
              <div class="font-18">汇信用</div>
              <div class="font-14">招标采购行业信用平台</div>
            </div>
          </div>
        </el-popover>
      </div>
      <div class="flex-1 m-l-20">
        <div class="flex color-2">
          <div class="nav-item font-18 font-bold pointer flex-center" @click="handleUrl(item)"
            v-for="(item, index) in navList" :key="index" :style="{width: !item.url ? '200px' : 'auto'}"
            @mouseover="handleTabMouseOver(index)" @mouseleave="handleTabMouseLeave">
            <span :class="[item.url === $route.path ? 'active' : '']">{{ item.label }}</span>
            <div v-if="item.list && curIndex == index" class="sub-nav-item-list">
              <div class="sub-nav-item" :class="[subItem.url === $route.path ? 'active' : '']"
                @click="handleUrl(subItem)" v-for="(subItem, subIndex) in item.list" :key="subIndex">{{ subItem.label }}
              </div>
            </div> <!-- Closing the div for item.list -->
          </div>
        </div>
      </div>
      <div class="p-r-10 flex">
        <div class="flex pointer" @click="handleLogout" v-if="$store.getters.token">
          <img width="18px" src="@/assets/index/logout.png" alt="" />
          <span class="color-6 font-14 m-l-10">退出账号</span>
        </div>
        <div class="flex pointer login-box" @click="handleLogin" v-else>
          <div>登录</div>
          <div class="login-line"></div>
          <div>注册</div>
        </div>
        <div class="flex header-tel m-l-16">
          <img width="32px" src="@/assets/index/tel.png" alt="" />
          <span>0851-84112474</span>
        </div>
      </div>
    </div>
  </div>
</template>
<script>
export default {
  data () {
    return {
      navList: [
        { label: '首页', url: '/' },
        {
          label: '企业征信产品', list: [
            { id: 1, label: '企业工商四要素核验', url: '/fourEssential' },
            { id: 2, label: '投标文件相似性分析', url: '/fileSimilarity' },
            { id: 3, label: '投标企业前置资格信息查询', url: '/prefixReport' },
            { id: 4, label: '招投标行业企业信用', url: '/creditReport' },
            { id: 6, label: '企业行业地位分析', url: '/standingReport' },
            { id: 7, label: '潜在供应商分析', url: '/analyzePush' },
            { id: 8, label: '投标人关联关系', url: '/relevanceReport' },
          ] },
        { id: 5, label: '私人订制', url: '/customized' },
      ],
      curIndex: -1
    }
  },
  methods: {
    handleHome () {
      this.$router.push({ path: '/' })
    },
    async handleLogout () {
      await this.$store.dispatch('user/logout')
    },
    handleUrl ({ url }) {
      if (!url) return
      if (url == '/customized' && !this.$store.getters.token) {
        this.$store.dispatch('user/loginMaskShow', new Date().getTime())
        return
      }
      this.$router.push({ path: url })
      this.curIndex = -1
    },
    handleTabMouseOver (index) {
      this.curIndex = index
    },
    handleTabMouseLeave () {
      this.curIndex = -1
    },
    handleLogin () {
      this.$store.dispatch('user/loginMaskShow', new Date().getTime())
    },
  }
}
</script>
<style lang="scss" scoped>
.header-box {
  position: fixed;
  left: 0;
  top: 0;
  width: 100%;
  height: 80px;
  min-width: 1366px;
  z-index: 10;

  .out-box {
    width: 1366px;
    margin: 0 auto;
    height: 80px;
    border-bottom: 1px solid #e6e6e6;

    .logo img {
      height: 50px;
    }

    .nav-item {
      padding: 0 20px;
      height: 80px;
      font-family: Microsoft YaHei;
      text-align: center;
      position: relative;

      &:hover {
        color: #3662F3;
      }

      &.active {
        color: #3662F3;
      }
    }
    .sub-nav-item-list{
      position: absolute;
      top: 80px;
      left: 0;
      width: 100%;
      background-color: #fff;
      border-radius: 5px;
      box-shadow: 0 2px 8px rgba(0, 0, 0, 0.15);
      z-index: 10;
      padding: 20px 0;

      .sub-nav-item {
        padding: 10px 20px;
        font-size: 14px;
        color: #666;

        &:hover {
          background-color: #f5f5f5;
          color: #3662F3;
        }
      }
    }
    .login-box{
      color: #3662F3;
      font-size: 18px;
      .login-line{
        margin: 0 10px;
        height: 20px;
        width: 1px;
        background-color: #333333;
      }
    }
    .header-tel {
      padding: 5px;
      font-size: 12px;
      border-radius: 25px;
      border: 1px solid #2552E0;

      span {
        display: block;
        white-space: nowrap;
        padding: 0 10px;
        color: #2552E0;
      }
    }

  }
}
</style>